import { withStyles } from '@mui/styles';
import { compose } from 'recompose';
import { styles } from './powered-by.styles';
import PoweredBy from './powered-by';

export default compose(withStyles(styles))(PoweredBy);
